(() => {
  const initializeDrumStickyCart = () => {
    const button = document.querySelector('sticky-atc-bar-minimalist [name="add"]');
    if (!button || document.documentElement.dataset.drumStickyCartBound === 'true') return;

    const syncStickyButton = () => {
      const mainForm = document.getElementById(button.getAttribute('form'));
      const mainSubmitButton = mainForm?.querySelector('[name="add"]');
      if (!mainSubmitButton) return;

      const isDisabled = mainSubmitButton.disabled || mainSubmitButton.getAttribute('aria-disabled') === 'true';
      const stickyButtonText = button.querySelector('.btn__text, span');
      const mainButtonText = mainSubmitButton.querySelector('.btn__text, span')?.textContent?.trim();

      button.disabled = isDisabled;
      if (isDisabled) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }

      if (stickyButtonText) {
        stickyButtonText.textContent = isDisabled
          ? (mainButtonText || 'Unavailable')
          : (window.FoxTheme?.variantStrings?.addToCartShort || 'Add');
      }
    };

    const updateStickyVisibility = () => {
      const stickyBar = document.querySelector('sticky-atc-bar-minimalist');
      const mainProductForm = document.querySelector('.main-product-form');
      if (!stickyBar || !mainProductForm) return;
      stickyBar.classList.toggle('sticky-atc-bar--show', mainProductForm.getBoundingClientRect().bottom < 0);
    };

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    updateStickyVisibility();

    const mainProductForm = document.getElementById(button.getAttribute('form'));
    if (mainProductForm) {
      const buttonObserver = new MutationObserver(syncStickyButton);
      buttonObserver.observe(mainProductForm, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });
    }

    document.addEventListener('variant:changed', () => queueMicrotask(syncStickyButton));
    syncStickyButton();

    document.documentElement.dataset.drumStickyCartBound = 'true';
    document.addEventListener('click', (event) => {
      const stickyButton = event.target.closest('sticky-atc-bar-minimalist [name="add"]');
      if (!stickyButton) return;

      event.preventDefault();
      if (stickyButton.disabled) return;

      const mainForm = document.getElementById(stickyButton.getAttribute('form'));
      const mainSubmitButton = mainForm?.querySelector('[name="add"]');
      if (!mainSubmitButton || mainSubmitButton.disabled) return;

      queueMicrotask(() => mainSubmitButton.click());
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDrumStickyCart, { once: true });
  } else {
    initializeDrumStickyCart();
  }
})();
